'use strict';

export class OwnershipService {
	static $inject = ['mx.internationalization'];

	constructor(i18n) {
		this.i18n = i18n;
	}

	getOwnershipTemplate(entity, editable) {
		const i18n = this.i18n;

		//TODO: move templates to component, to html files and inject just <mx-ownership-container>
		const getLinkTemplate = function (entityName, className, attributeName, label) {
			return (
				'<!--CONTAINER-->' +
				'<div mx-container data-behavior="hide-empty" id="layout-container-ao1-' +
				attributeName +
				'" ' +
				'	  class="mx-flex-3 flex layout_container_mode_default">' +
				'	<div class="layout_container_mode_default_inner">' +
				'		<div class="mx-layout-container-content layout-column layout-sm-column layout-xs-column ' +
				'					layout-align-xs-start-stretch layout-align-sm-start-stretch">' +
				'<mx-object-link value="vm.dataModel.' +
				entityName +
				'.SPSCommonClassBase.' +
				attributeName +
				'" ' +
				'				entity-class-name="' +
				className +
				'" ' +
				'				label="' +
				label +
				'" ' +
				'				designer-mode="false" ' +
				'				data-type="string" ' +
				'				label-position="top" ' +
				'				label-first="true"  ' +
				'				mx-at-id="auto-ownership-link-' +
				attributeName +
				'" ' +
				'				data-visual-type="control">' +
				'</mx-object-link>' +
				'</div></div></div>'
			);
		};

		const getPickerTemplate = function (entityName, className, attributeName, label) {
			return (
				'<!--CONTAINER-->' +
				'<div mx-container data-behavior="hide-empty" id="layout-container-ao1-' +
				attributeName +
				'" ' +
				'	  class="mx-flex-3 flex layout_container_mode_default">' +
				'	<div class="layout_container_mode_default_inner">' +
				'		<div class="mx-layout-container-content layout-column layout-sm-column layout-xs-column ' +
				'					layout-align-xs-start-stretch layout-align-sm-start-stretch">' +
				'<mx-object-picker ng-model="vm.dataModel.' +
				entityName +
				'.SPSCommonClassBase.' +
				attributeName +
				'" ' +
				'				entity-class-name="' +
				className +
				'" ' +
				'				label="' +
				label +
				'" ' +
				'				mx-at-id="auto-ownership-picker-' +
				attributeName +
				'" ' +
				'				data-visual-type="edit-control">' +
				'</mx-object-picker>' +
				'</div></div></div>'
			);
		};

		const getControl = function (entityName, className, attributeName, label) {
			return (editable ? getPickerTemplate : getLinkTemplate)(entityName, className, attributeName, label);
		};

		return (
			'<div mx-row class="layout-row"><div mx-container data-behavior="hide-empty" id="layout-container-auto-ownership" ' +
			'	class="mx-flex-10 flex">' +
			'	<div class="layout_container_mode_default_inner">' +
			'		<div class="panel-title">' +
			i18n.get('serviceStore.ownership.ownership') +
			'</div>' +
			'		<div class="mx-layout-container-content layout-column">' +
			'			<div mx-rows-container class="layout-row-container">' +
			'			<!--ROW--><div mx-row class="layout-row layout-sm-column layout-xs-column">' +
			getControl(entity, 'SPSOrgUnitClassBase', 'OU', i18n.get('serviceStore.ownership.ou')) +
			getControl(entity, 'SPSLocationClassBase', 'Location', i18n.get('serviceStore.ownership.location')) +
			getControl(entity, 'SPSCostCenterClassBase', 'CostCenter', i18n.get('serviceStore.ownership.cost-center')) +
			'</div></div></div></div></div></div>' +
			'<div mx-row class="layout-row">' +
			'	<div mx-container id="layout-auto-ownership-divider" class="mx-flex-10 flex layout_container_mode_default">' +
			'		<div class="layout_container_mode_default_inner">' +
			'			<div class="mx-layout-container-content layout-column">' +
			'				<div fixed-layout="false" class="mx-layout-divider" mx-at-id="auto-ownership-divider" data-visual-type="control" role="separator">' +
			'</div></div></div></div></div>'
		);
	}

	injectOwnershipContainer(widget, isCreateDialogWidget) {
		if (!widget || !widget.Template || !widget.Entity || !widget.ShowOwnership || !widget.Template.Views || !widget.Template.Views.length) {
			return widget;
		}

		widget.Template.Views = widget.Template.Views.sort(function (view1, view2) {
			return view1.Position - view2.Position;
		});

		if (!widget.Template.Views[0].Template) {
			return widget;
		}

		const template = this.getOwnershipTemplate(widget.Entity, isCreateDialogWidget);

		const anchor = '<!--ROW-->';

		widget.Template.Views[0].Template = widget.Template.Views[0].Template.replace(anchor, template + anchor);

		return widget;
	}
}
